import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import CourseEditPage from './CourseEditPage';
import Chapter from './chapters/Chapter';
import { fetchChapters } from './chapters/actions';
import Loading from '../common/components/Loading';

class Course extends Component {
  componentDidMount() {
    this.props.dispatch(fetchChapters(this.props.match.params.courseId));
  }

  render() {
    const { match, chaptersLoaded } = this.props;

    if (!chaptersLoaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={CourseEditPage} />
        <Route path={`${match.path}/chapters/:chapterId`} component={Chapter} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    chaptersLoaded: state.courses.chapters.get('loaded'),
  };
};

export default connect(mapStateToProps)(Course);



// WEBPACK FOOTER //
// ./src/courses/Course.js